import { env } from '../app.conf';
import { setAccessTokenCookie } from '../../utils/authUtils';

export default async function FamlaServices(services, link, method, form, token, extraHeaders = null) {
    let headers = {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
    };

    if (extraHeaders && typeof extraHeaders === 'object') {
        headers = { ...headers, ...extraHeaders };
    }

    let body = JSON.stringify(form);
    let url = env[services] + link;

    if (form instanceof FormData) {
        headers = { Accept: "application/json" };
        body = form;
    }

    if (token) {
        setAccessTokenCookie(token);
        headers = { ...headers, Authorization: `Bearer ${token}` };
    }

    let request = new Request(url, {
        mode: "cors",
        method: method,
        headers: headers,
        credentials: 'include', // Envoie les cookies pour l'authentification cross-origin
    });

    if (method !== "GET" && method !== "HEAD") {
        request = new Request(url, {
            mode: "cors",
            method: method,
            headers: headers,
            body,
            credentials: 'include', // Envoie les cookies pour l'authentification cross-origin
        });
    }

    const resp = await fetch(request);

    const responseHeaders = {};
    resp.headers.forEach((value, key) => {
        responseHeaders[key] = value;
    });

    if (resp.status === 304) {
        return { status: 304, body: null, contentType: resp.headers.get("Content-Type"), headers: responseHeaders };
    }

    // Récupération du Content-Type
    const contentType = resp.headers.get("Content-Type");

    // Vérifie si la réponse est un fichier (PDF, XLS, XLSX, CSV, XML)
    if (contentType && (contentType.includes("application/pdf") ||
        contentType.includes("application/vnd.ms-excel") ||
        contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
        contentType.includes("text/csv") ||
        contentType.includes("text/xml") ||
        contentType.includes("application/xml"))) {
        const blob = await resp.blob();
        return { status: resp.status, body: blob, contentType, headers: responseHeaders };
    }

    // Sinon, traite comme JSON
    const data = await resp.json();
    return { status: resp.status, body: data, contentType, headers: responseHeaders };
}
